<script>
let customerId = window.localStorage.getItem("customerId");
import baseList from "@/views/components/base/baseList.vue";
import fileEdit from "./fileEdit.vue";
import { IMAGE_HOST } from "../../../config";

export default {
  extends: baseList,
  components: {
    fileEdit,
  },
  data() {
    return {
      table: {
        mname: "resourceDownload",
        key: "id",
        url: {
          list: "/admin/system/resourceDownload/list",
          del: "/admin/system/resourceDownload",
        },
        output: false,
      },
      customerId: "",
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
        },
      ],

      filters: [
        {
          label: "适用型号",
          name: "content",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "名称",
          name: "name",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center',
        },
        {
          title: "名称",
          minWidth: 200,
          align: "left",
          key: "name",
        },
        {
          title: "备注",
          minWidth: 200,
          align: "left",
          key: "content",
        },
        {
          title: "状态",
          width: 120,
          align: "center",
          key: "delStatus",
          render: (p, params) => {
            let row = params.row;
            return <span>{row.delStatus == 1 ? "展示" : "不展示"}</span>;
          },
        },
        // {
        //   title: "上传时间",
        //   width: 120,
        //   align: "left",
        //   // key: 'classesDate'
        //   render: (p, params) => {
        //     let row = params;
        //     console.log(params);
        //     return <span>2025-01-20</span>;
        //   },
        // },
        // {
        //   title: "备注",
        //   width: 180,
        //   align: "left",
        //   key: "remark",
        // },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.downloadFile(currentRow.path)}
                  type="default"
                  style={{
                    border: "none",
                    marginRight: "5px",
                    color: "#4991ff",
                  }}
                >
                  下载
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.fileEditFun(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    marginRight: "5px",
                    color: "#4991ff",
                  }}
                >
                  编辑
                </Button>
              );
            },
            "delete",
          ],
        },
      ],
    };
  },
  created() { },
  methods: {
    /*  downloadFile(row) {
       console.log(row);
       // window.open(IMAGE_HOST + row.path, "_self");
     }, */
    downloadFile(text) {
      const texturl = text.split(",");
      /* for (let i = 0; i < texturl.length; i++) {
        texturl[i] = IMAGE_HOST + texturl[i];
      } */
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `下载附件`,
        width: "600px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <p
                        style="color:#4991ff; cursor: pointer;"
                        onClick={() => window.open(IMAGE_HOST + item.url, "_self")}
                      >
                        {item.name}
                      </p>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    fileEditFun(row) {
      console.log(row);

      let that = this;
      this.$Modal.success({
        closable: true,
        title: "新增",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <fileEdit
              onSearchFun={(e) => {
                that.search();
              }}
              kvId={row.id}
              actions="edit"
            />
          );
        },
      });
    },
    toAdd() {
      let that = this;
      this.$Modal.success({
        closable: true,
        title: "新增",
        width: "800px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <fileEdit
              onSearchFun={(e) => {
                that.search();
              }}
            />
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
